export const MediaEnum = {
  MediaTypeId: {
    lookupTypeId: 8,
  },
  MediaDetailsId: {
    lookupTypeId: 1240,
  },
};
